import Vue from "vue";
import Vuex from "vuex";

import { mutations } from "@/store/mutations";
import { actions } from "@/store/actions";
import { getters } from "@/store/getters";
import createPersistedState from "vuex-persistedstate";
// import LogRocket from "logrocket";
// import createPlugin from "logrocket-vuex";

// const logrocketPlugin = createPlugin(LogRocket);

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "vuex",
      paths: ["user"],
    }),
  ],
  state: {
    search: "",
    components: [],
    componentTypes: [],
    componentTypesError: "",
    componentFilters: { type: "", status: "", inventoryId: "" },
    proCameraFilters: { status: "", sortBy: "id", sortOrder: "desc" },
    proCameraListError: "",
    componentRevision: 0,
    componentListError: "",
    filters: {
      role: "",
      status: "",
      company: "",
      project: "",
      showDeleted: false,
      snapshotSuspended: false,
    },
    isSaving: false,
    isLoadingSync: false,
    toastMessage: "",
    toastState: false,
    toastType: "info",
    modalStack: [], // New modal stack system
    tabs: [
      {
        table: "components",
        name: '<span class="icon"><i class="fas fa-microchip"></i></span> Components',
        isActive: false,
        childComponent: "ComponentList",
        currentPage: 1,
        size: 10,
        totalRecords: 0,
        totalPages: 0,
      },
      {
        table: "dashboard",
        name: '<span class="icon"><i class="fas fa-chart-line"></i></span> Dashboard',
        isActive: true,
        childComponent: "Dashboard",
        modal: null,
        currentPage: 1,
        size: 10,
        totalRecords: 0,
        totalPages: 0,
      },
      {
        table: "users",
        name: '<span class="icon"><i class="fas fa-users"></i></span> Users',
        isActive: false,
        childComponent: "userList",
        modal: "modalUser",
        currentPage: 1,
        size: 10,
        totalRecords: 0,
        totalPages: 0,
      },
      {
        table: "companies",
        name: '<span class="icon"><i class="fas fa-building"></i></span> Companies',
        isActive: false,
        childComponent: "companyList",
        modal: "modalCompany",
        currentPage: 1,
        size: 10,
        totalRecords: 0,
        totalPages: 0,
      },
      {
        table: "projects",
        name: '<span class="icon"><i class="fas fa-project-diagram"></i></span> Projects',
        isActive: false,
        childComponent: "projectList",
        modal: "modalProject",
        currentPage: 1,
        size: 10,
        totalRecords: 0,
        totalPages: 0,
      },
      {
        table: "cameras",
        name: '<span class="icon"><i class="fas fa-video"></i></span> Cameras',
        isActive: false,
        childComponent: "cameraList",
        modal: "modalCamera",
        currentPage: 1,
        size: 10,
        totalRecords: 0,
        totalPages: 0,
      },
      {
        table: "contracts",
        name: '<span class="icon"><i class="fas fa-file-contract"></i></span> Contracts',
        isActive: false,
        childComponent: "contractList",
        modal: "modalContract",
        currentPage: 1,
        size: 10,
        totalRecords: 0,
        totalPages: 0,
      },
      {
        table: "video_orders",
        name: '<span class="icon"><i class="fas fa-film"></i></span> Video Orders',
        isActive: false,
        childComponent: "videoOrderList",
        modal: "modalVideoOrder",
        currentPage: 1,
        size: 10,
        totalRecords: 0,
        totalPages: 0,
      },
      {
        table: "pro_camera_inventories",
        name: '<span class="icon"><i class="fas fa-camera-retro"></i></span> Pro Camera Inventory',
        isActive: false,
        childComponent: "proCameraInventoryList",
        modal: null,
        currentPage: 1,
        size: 10,
        totalRecords: 0,
        totalPages: 0,
      },
    ],
    isModalOpen: false, // Deprecated - kept for backward compatibility
    modalActiveTabIndex: 0, // Deprecated - kept for backward compatibility
    user: {
      id: null,
      fullName: "",
      isAuthenticated: false,
      permissions: [],
    },
    users: [],
    companies: [],
    contracts: [],
    video_orders: [],
    pro_camera_inventories: [],
    cameras: [],
    projects: [],
    selectedCamera: {
      id: null,
      name: "",
      project_id: "",
      aws_bucket: "",
      aws_folder: "",
      aws_region: "",
      timezone: "",
      schedule_group: "",
      company: "",
      heading: 0,
      location: { latitude: 0.0, longitude: 0.0 },
    },
    selectedUser: {
      id: null,
      fullName: "",
      email: "",
      password: "",
      cameras: [],
      projects: [],
      roles: [],
    },
    selectedCompany: {
      id: null,
      name: "",
      awsBucket: "",
      awsRegion: "",
      awsIotUser: "",
      awsIotUserPolicy: "",
      awsUploadKey: "",
      awsUploadSecret: "",
      roles: [],
      users: [],
    },
    selectedProject: {
      id: null,
      name: "",
      company: null,
    },
    selectedContract: {
      id: 0,
      created_at: new Date(),
      updated_at: new Date(),
      company_id: 0,
      user_id: 0,
      package_id: 0,
      start_date: new Date(),
      end_date: new Date(),
      amount: 0.0,
      currency: "USD",
      package_name: "",
      features: {},
      status: "",
      is_trial: false,
      next_invoice_date: null,
      is_canceled: false,
    },
    selectedInvoice: {
      id: 0,
      created_at: new Date(),
      updated_at: new Date(),
      company_id: 0,
      amount: 0.0,
      currency: "",
    },
    selectedProCameraInventory: {
      id: null,
      serial_number: "",
      camera_status: "pending",
      camera_id: null,
    },
  },
  mutations,
  actions,
  getters,
});

export default store;
